import { ModalFooter, ModalFooterButton } from '@/components/Modal'

import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

type Props = {
  onSubmit: () => void
}

export function Footer(props: Props) {
  const { onSubmit } = props

  const texts = useTexts()

  const { close, status } = useController()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          disabled={status !== 'ready'}
          loading={status !== 'ready'}
          onClick={onSubmit}
          variant="contained"
          testid="modal__button-save"
        >
          {texts.saveButtonTitle}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton disabled={status !== 'ready'} onClick={close}>
          {texts.cancelButtonTitle}
        </ModalFooterButton>
      }
    />
  )
}
